import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { MEMBER_SORTABLE } from '../vocabulary'
import { membersQuery } from './queries'

const membersSearch = (raw: Record<string, unknown>) => listQueryOf(raw, MEMBER_SORTABLE)

export const membersRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('users'),
  path: '/users',
  validateSearch: membersSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(membersQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'MembersPage'),
})

export const memberRoutes = [membersRoute]
